/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2020-06-04 14:24:06
 * @LastEditors: your name
 * @LastEditTime: 2022-01-17 16:11:42
 */
import request from "@/utils/request";

// 系统登录
export const login = data => {
  return request({
    url: "/api/hz-smart-community/sys/login",
    method: "post",
    data: data
  });
};
// POST /auth/user/account

// cardId登录
export const cardLogin = data => {
  return request({
    url: "/apiData/hz-data-community/auth/user/account",
    method: "post",
    data: data,
  });
};
// 退出登录
export const logout = () => {
  return request({
    url: "/api/hz-smart-community/sys/logout",
    method: "post"
  });
};